import React from "react";

export default function ColorPicker(props) {
    const { onInput, ...rest } = props;
    return (
        <div className="flex items-center gap-3">
            <input
                type="color"
                className="w-8 h-8 cursor-pointer border rounded border-gray-300"
                {...rest}
            />

            <input
                type="text"
                className="border rounded px-2 py-1 w-28 text-sm border-gray-300 shadow-sm focus:outline-none"
                onInput={e => onInput(e.currentTarget.value)}
                {...rest}
            />
        </div>
    );
}
